/*
 * Obrah — Title Case normalizer (client-side, frontend only).
 *
 * Aplica Title Case nos NOMES DE OBRAS exibidos na vitrine — PDP, cards de
 * coleção, busca, carrinho, predictive search etc. Não mexe no dado salvo
 * no Shopify; só reescreve o texto renderizado.
 *
 * Regras:
 * - Primeira e última palavra: SEMPRE capitalizadas.
 * - Artigos, conjunções e preposições curtas no MEIO ficam em minúsculas
 *   (PT: a, à, o, ao, as, às, os, aos, e, ou, de, da, do, das, dos, em, no,
 *    na, nos, nas, por, para, com; EN: a, an, the, and, or, but, at, in, on,
 *    of, to, for, by, with).
 * - Demais palavras: inicial maiúscula.
 * - Hífens preservados; cada parte hifenizada é capitalizada (Saint-Tropez).
 * - Acentos, pontuação e números preservados.
 */
(function () {
  'use strict';

  var STOPWORDS = new Set([
    // English
    'a', 'an', 'the', 'and', 'or', 'but',
    'at', 'in', 'on', 'of', 'to', 'for', 'by', 'with',
    // Português
    'o', 'as', 'os', 'à', 'ao', 'às', 'aos',
    'e', 'ou', 'de', 'da', 'do', 'das', 'dos',
    'em', 'no', 'na', 'nos', 'nas',
    'por', 'para', 'com'
    // 'a' já está acima (compartilhado com EN)
  ]);

  // Seletores onde nomes de obras aparecem na PDP. Escopo restrito à
  // página de produto — coleção, carrinho e busca ficam intocados.
  var SELECTORS = [
    'h1.product-title',
    '.product-title-card__name',
    '.pp26-gallery__title-card-name',
    '.product-add-to-cart-sticky--title'
  ];

  var DONE_ATTR = 'data-tc-done';

  function capitalizeFirstLetter(word) {
    // Acha a primeira letra (unicode aware) e capitaliza preservando o que
    // vier antes (pontuação como aspas, parênteses, etc.).
    var m = word.match(/[\p{L}]/u);
    if (!m) return word;
    var i = word.indexOf(m[0]);
    return word.slice(0, i) + word.charAt(i).toLocaleUpperCase('pt-BR') + word.slice(i + 1);
  }

  function normalizeWord(word, isEdge) {
    var lower = word.toLocaleLowerCase('pt-BR');
    // Token só com letras pra comparar com stopwords.
    var stripped = lower.replace(/[^\p{L}]/gu, '');
    if (!isEdge && STOPWORDS.has(stripped)) return lower;
    // Hifenizadas: capitaliza cada parte (Saint-Tropez, Anglo-Saxã).
    return lower.split('-').map(capitalizeFirstLetter).join('-');
  }

  function toTitleCase(str) {
    if (!str) return str;
    var trimmed = str.trim();
    if (!trimmed) return str;
    var words = trimmed.split(/\s+/);
    var last = words.length - 1;
    return words.map(function (w, i) {
      return normalizeWord(w, i === 0 || i === last);
    }).join(' ');
  }

  function applyToElement(el) {
    if (!el || el.hasAttribute(DONE_ATTR)) return;
    // Caso 1: elemento só com texto direto (sem filhos elementares).
    if (el.children.length === 0) {
      var original = el.textContent;
      var t = original.trim();
      if (!t) return;
      var normalized = toTitleCase(t);
      if (normalized !== t) {
        // Preserva eventuais espaços/linhas em volta.
        el.textContent = original.replace(t, normalized);
      }
      el.setAttribute(DONE_ATTR, '1');
      return;
    }
    // Caso 2: tem filhos — só mexe nos TEXT NODES diretos (não recursivo,
    // pra evitar alterar preço, badges, etc. dentro do mesmo wrapper).
    el.childNodes.forEach(function (n) {
      if (n.nodeType !== 3) return; // só text nodes
      var t = n.textContent.trim();
      if (!t) return;
      var normalized = toTitleCase(t);
      if (normalized !== t) n.textContent = n.textContent.replace(t, normalized);
    });
    el.setAttribute(DONE_ATTR, '1');
  }

  function applyAll(root) {
    root = root || document;
    SELECTORS.forEach(function (sel) {
      root.querySelectorAll(sel).forEach(applyToElement);
    });
  }

  // Run inicial.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applyAll(); });
  } else {
    applyAll();
  }

  // MutationObserver — captura conteúdo dinâmico (cart drawer, predictive
  // search, quick view, infinite scroll de coleção, etc.).
  if (window.MutationObserver) {
    var scheduled = false;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(function () {
            scheduled = false;
            applyAll();
          });
          return;
        }
      }
    });
    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  // Expõe pra debug/uso manual em qualquer lugar do tema se precisar.
  window.ObrahTitleCase = { apply: applyAll, toTitleCase: toTitleCase };
})();
